import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 12px;
`

export const ProfessionalDataContainer = styled.section``

export const AcademicFormationContainer = styled.section`
  margin-top: 40px;
`

export const SpecialtiesContainer = styled.section`
  margin-top: 40px;
`

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 24px;
`

export const PendencySelection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const InputsContainer = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  align-items: end;

  section {
    display: flex;
    gap: 16px;
  }

  @media (max-width: 1600px) {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
  }

  section {
    display: flex;
    align-items: end;
  }

  > input:last-child {
    margin-right: 0;
  }
`

export const DirectorObservations = styled.div`
  margin-top: 48px;

  textarea {
    height: 160px;
  }
`

export const PendencyJustification = styled.div`
  margin-top: 80px;

  textarea {
    height: 160px;
  }
`

export const TeamItem = styled.div`
  padding: 6px 20px;
  border-radius: 20px;
  margin-right: 8px;
  margin-top: 8px;
  background-color: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 350px;

  label {
    color: #fff;
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button {
    margin-left: 8px;
    cursor: pointer;
    background: none;
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    padding: 2px;
    border-radius: 50%;
  }
`

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 48px;

  button {
    background-color: ${({ theme }) => theme.colors.mainBg};
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`

export const TeamsContainer = styled.section`
  margin: 48px 0;

  ul {
    display: flex;
    padding: 12px;
    margin-top: 12px;
    border-radius: ${({ theme }) => theme.border.radius.small};
    background-color: ${({ theme }) => theme.colors.white};

    li {
      padding: 4px 10px;
      font-size: ${({ theme }) => theme.font.sizes.xsmall};
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
      border-radius: ${({ theme }) => theme.border.radius.medium};
    }
  }
`
